var React = require('react');

function MessageSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M84 60C84 62.1217 83.1571 64.1566 81.6569 65.6569C80.1566 67.1571 78.1217 68 76 68H28L12 84V20C12 17.8783 12.8429 15.8434 14.3431 14.3431C15.8434 12.8429 17.8783 12 20 12H76C78.1217 12 80.1566 12.8429 81.6569 14.3431C83.1571 15.8434 84 17.8783 84 20V60Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MessageSquare.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = MessageSquare;

MessageSquare.default = MessageSquare;
